import { Outlet, useParams } from "react-router-dom";
import QueryWrapper from "common/components/QueryWrapper";
import { BingoScreenLayout } from "common/layouts/BingoScreenLayout";
import { useGetBingoGameQuery } from "bingo/api/bingo-game.api";
import { withDebug } from "common/debug/components/withDebug";

function BingoScreenShellWithGameWrapperComponent() {
  const { bingoGameId } = useParams();
  const getBingoGameQuery = useGetBingoGameQuery(bingoGameId!);

  return (
    <QueryWrapper query={getBingoGameQuery}>
      {(bingoGame) => (
        <BingoScreenLayout theme={bingoGame}>
          <Outlet />
        </BingoScreenLayout>
      )}
    </QueryWrapper>
  );
}

export const BingoScreenShellWithGameWrapper = withDebug(
  BingoScreenShellWithGameWrapperComponent,
);
